import { jsx as _jsx } from "react/jsx-runtime";
export const FormErrorText = (props) => {
    return (_jsx("div", { role: "alert", className: "ant-form-item-explain-error", ...props }));
};
